import React from "react";
import { useTranslation } from "react-i18next";

import css from "../../insights_page.module.scss";
import { SubPageHeader } from "../../sub_page_header";

export const DailyBench = () => {
  const { t } = useTranslation("insights");

  return (
    <div className={css.subPageContainer}>
      <SubPageHeader title={t("subPage.dailyBench")} />
    </div>
  );
};
